import React from "react";
import AddIcon from "@mui/icons-material/Add";

import { Audience, SimpleAudience } from "modules/audiences";
import MultiSelectCalloutWithSearch from "modules/common/components/forms/inputs/multiSelectCalloutWithSearch";
import ChipListWithButton from "modules/common/components/ChipsListWithButton";

import "../components/messaging/messagingSMSControls.sass";

interface IVerifyAudiencesSectionProps {
    audiences: Audience[];
    optInInviteAudiences: SimpleAudience[];
    isFetching: boolean;
    setOptInInviteAudiences: (audiences: string[]) => any;
    getAudienceUsersCSV: (audienceIds: string[], filename: string) => void;
}

const VerifyInviteAudiencesSection: React.FC<IVerifyAudiencesSectionProps> = ({
    audiences,
    isFetching,
    optInInviteAudiences,
    setOptInInviteAudiences,
    getAudienceUsersCSV
}) => {
    return (
        <div className="sms-section">
            <div className="text-section">
                <div className="title-and-description">
                    <b className="title">Audiences for SMS Opt-In Invites</b>   
                    <p className="description">Select the audiences to automatically send an SMS opt-in invite to. Invites are sent when the account's mobile number is newly added or updated.</p>
                </div>
                {audiences.length !== 0 &&
                    <MultiSelectCalloutWithSearch
                        defaultOptions={audiences.map(opt => ({id: opt.id, name: opt.displayName}))}
                        containerClassName={"settings-title-button-long"}
                        selectedOptions={optInInviteAudiences}
                        onChange={(audiences) => setOptInInviteAudiences(audiences.map(a => a.id))}
                        buttonStyle={{
                            startIcon: <AddIcon/>,
                            buttonText: "Add/Edit Audiences"
                        }}
                        nestingAllowed={false}
                        searchBarText={"Search audiences"}
                        buttonId={"select-opt-in-audiences-button"}
                    />
                }
            </div>
            <div>
                {optInInviteAudiences.length > 0
                    ? <ChipListWithButton 
                        downloadText="Download CSV"
                        isFetching={isFetching}
                        items={optInInviteAudiences}
                        onClick={() => getAudienceUsersCSV(optInInviteAudiences.map(f => f.id), `opt_in_invite_list.csv`)}
                        onChipClose={(audience) => setOptInInviteAudiences(optInInviteAudiences.map(a => a.id).filter(a => a !== audience.id))}
                    />
                    : <p className="description" style={{fontStyle: "italic"}}>No audiences are set for opt-in invites</p>
                }
            </div>
        </div>
    );
}

export default VerifyInviteAudiencesSection;